import { Controller } from "@hotwired/stimulus";
import { destroy, post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['resetEditor']
  static values = {
    createAdjacentRowUrl: String,
    deleteRowUrl: String,
    updateCellUrl: String,
  }

  scriptCells = []

  connect() {
    this.setup()
  }

  setup(){
    this.scriptCells = this.element.querySelectorAll("[data-script-cell]")

    this.addActionsToCells(this.scriptCells)
  }

  addActionsToCells(scriptCells){
    scriptCells.forEach((scriptCell) => {
      const textArea = scriptCell.getElementsByTagName('textarea')[0]
      if (textArea){
        // onBlur - Update
        textArea.addEventListener("blur", (e) => {
          this.updateCellContent(e)
        })

        // Shortcuts
        textArea.addEventListener('keydown', (e) => {
          // Modifier - Ctrl or Cmd
          if (!(e.ctrlKey || e.metaKey)) return

          // Modifier + Enter
          if (e.code == 'Enter'){
            this.addNewRow(e)
            return
          }

          // Modifier + Backspace
          if (e.code == 'Backspace'){
            this.deleteRow(e)
            return
          }
        })
      }
    })
  }

  async updateCellContent(e){
    if (this.updateCellUrlValue){
      const { columnId, rowId, scriptId } = e.target.dataset

      await post(this.updateCellUrlValue, {
        contentType: 'application/json',
        body: JSON.stringify({
          script_cell: {
            content: e.target.value,
            script_column_id: columnId,
            script_id: scriptId,
            script_row_id: rowId,
          },
        }),
      })
    }
  }

  async addNewRow(e){
    // Save current cell
    await this.updateCellContent(e)

    // Create new row
    if (this.createAdjacentRowUrlValue){
      const { rowId } = e.target.dataset

      await post(this.createAdjacentRowUrlValue, {
        contentType: 'application/json',
        body: JSON.stringify({
          insert_position: "after",
          script_row_id: rowId,
        }),
        responseKind: 'turbo-stream',
      })
    }
  }

  async deleteRow(e){
    if (this.deleteRowUrlValue){
      const { rowId } = e.target.dataset

      const url = this.deleteRowUrlValue.replace('SCRIPT_ROW_ID', rowId)

      await destroy(url, {
        contentType: 'application/json',
        responseKind: 'turbo-stream',
      })
    }
  }

  resetEditorTargetConnected(e){
    this.setup()
  }
}
